import { render } from "./DeleteRefStdLink.vue?vue&type=template&id=68549e96"
import script from "./DeleteRefStdLink.vue?vue&type=script&lang=js"
export * from "./DeleteRefStdLink.vue?vue&type=script&lang=js"

import "./DeleteRefStdLink.vue?vue&type=style&index=0&id=68549e96&lang=scss"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__